<template>
  <b-modal id="modalCreateMassiveSummaries"
    centered size="lg"
    title="Crear manifiestos"
    hide-footer
    @close="onCloseModal"
    no-close-on-esc
    no-close-on-backdrop>
    <b-overlay :show="loading.checkDeliveries" rounded="sm" opacity="0.8" variant="white">
      <!-- Sección inputs -->
      <div v-show="show.form">
        <b-alert
          class="p-1 col-md-12"
          variant="warning"
          show
          dismissible>
          <div class="d-flex justify-content-center align-items-center">
            <feather-icon size="20" class="mr-50" icon="CircleCheckIcon" />
            <span>
              <strong>Recomendación:</strong> Ingrese un máximo de 1000 envíos para un rendimiento óptimo.
            </span>
          </div>
        </b-alert>
        <form-render :fields="fields" :form.sync="form" ref="formRenderCreateMassiveSummary" containerButtonsClass="col-sm-12" />
        <b-alert class="p-1 col-md-12" variant="primary" show>
          <div class="d-flex justify-content-center align-items-center">
            <feather-icon size="20" class="mr-50" icon="InfoIcon"/>
            <span>
              No se considerarán los envíos repetidos.
            </span>
          </div>
        </b-alert>

        <!-- Botón para validar envíos -->
        <div class="d-flex justify-content-end align-items-center">
          <small v-if="show.exceededWarning" class="text-danger ml-2">
            Has superado el límite recomendado de 1000 envíos.
          </small>
          <b-button
            class="m-1"
            variant="warning"
            @click="checkDeliveries"
            :disabled="loading.checkDeliveries || disabled.checkDeliveriesBtn">
            <span class="mb-1">{{$t('Validar envíos')}}</span>
            <b-spinner v-if="loading.checkDeliveries" class="ml-1" small/>
          </b-button>
        </div>
      </div>

      <!-- Sección de confirmación -->
      <div v-show="show.responseDeliveries">
        <b-alert class="p-1 col-md-12" variant="warning" show v-if="show.processDeliveries">
          <div class="d-flex justify-content-center align-items-center">
            <feather-icon size="20" class="mr-50" icon="InfoIcon"/>
            <span>
              <strong>IMPORTANTE:</strong> Si continúa, se creará(n) {{ checkDeliveriesData.total_summaries }} manifiesto(s) con los envíos procesados correctamente.
            </span>
          </div>
        </b-alert>

        <template v-if="show.failedDeliveries">
          <p class="highlighted-text">Se encontraron los siguientes envíos con errores:</p>
          <!-- Card para mostrar los errores -->
          <b-card class="mb-1 error-list-card">
            <p class="error-text" v-for="(failed_delivery, index) in checkDeliveriesData.failed_deliveries" :key="index">
              <strong>{{ index + 1 }} -</strong> {{ failed_delivery }}
            </p>
          </b-card>
        </template>

        <template v-if="show.processDeliveries">
          <p class="highlighted-text">Se procesaron {{ checkDeliveriesData.process_deliveries_count }} envíos correctamente.</p>
          <table-render id="table-checked-deliveries-to-print"
            class="error-list-card"
            :schema="schema"
            :rows="rows"
            :fixed="true"
            showCheckboxes="true"
            :selectedRows.sync="selectedRows">
          </table-render>
        </template>

        <b-alert class="p-1 col-md-12" variant="primary" show v-if="!show.processDeliveries && show.failedDeliveries">
          <div class="d-flex justify-content-center align-items-center">
            <feather-icon size="20" class="mr-50" icon="InfoIcon"/>
            <span>
              No se ha procesado ningún envío de forma correcta, no es posible crear ningún manifiesto.
            </span>
          </div>
        </b-alert>
        <!-- Contenedor para los botones -->
        <div class="modal-manifest--button--container">
          <b-button variant="warning" :disabled="disabled.createSummariesBtn" @click="backToInputs"> <feather-icon icon="ArrowLeftIcon"/> Volver</b-button>
          <b-button variant="success" :disabled="disabled.createSummariesBtn || (!show.processDeliveries && show.failedDeliveries)" @click="createSummaries">
            Crear Manifiestos
            <feather-icon v-if="!loading.createSummariesBtn" icon="FileTextIcon"/>
            <b-spinner v-else class="ml-1" small/>
          </b-button>
        </div>
        <!-- Texto de aviso -->
        <p v-if="loading.createSummariesBtn" class="mr-1 text-muted text-right">
          Esta acción puede tardar un poco, por favor espere...
        </p>
      </div>

      <template #overlay>
        <div class="text-center">
          <b-spinner small type="grow" variant="secondary"></b-spinner>
          <b-spinner type="grow" variant="dark"></b-spinner>
          <b-spinner small type="grow" variant="secondary"></b-spinner>
          <div>
            <feather-icon icon="PackageIcon" size="3x"></feather-icon>
          </div>
          <p id="cancel-label">Por favor espere, se estan validando los envíos ...</p>
          <!-- <b-button
            variant="outline-danger"
            size="sm"
            aria-describedby="cancel-label"
            @click="loading.checkDeliveries = false"
          >
            Cancelar
          </b-button> -->
        </div>
      </template>
    </b-overlay>
  </b-modal>
</template>

<script>
import BaseServices from '@/store/services/index'
import {endpoint} from './../endpoints.service.js'
export default {
  name: 'modal-create-massive-summaries',
  props: ['sourceList'],
  data() {
    return {
      baseService: new BaseServices(this),
      fields: [],
      form: {},
      schema: [],
      selectedRows: [],
      rows: [],
      loading: {
        checkDeliveries: false,
        createSummariesBtn: false
      },
      disabled: {
        checkDeliveriesBtn: true,
        createSummariesBtn: false
      },
      show: {
        form: true,
        responseDeliveries: false,
        processDeliveries: false,
        failedDeliveries: false,
        exceededWarning: false
      },
      checkDeliveriesData: {},
      ROLES : {
        marketplace: 'marketplace',
        ecommerce: 'ecommerce',
        seller: 'seller',
        admin: 'admin'
      }
    }
  },
  mounted () {
    this.setInitialData()
  },
  computed: {
    user() {
      return this.$session.get('cas_user')
    },
    source() {
      return this.sourceList || this.$route.query.source || 'delivery'
    },
    isSourceDelivery() {
      return this.source === 'delivery'
    },
    endpointValues() {
      return endpoint[this.source]
    }
  },
  methods: {
    setInitialData() {
      this.fields = [
        {
          fieldType: 'FieldTextarea',
          name: 'ids',
          label: 'Agregue o pegue los envíos que desea buscar separados por un "Enter"',
          containerClass: 'col-sm-12 container-info',
          change: this.onChangeImportedIds,
          rows: 8
        }
      ]
      this.schema = [
        { label: 'Empresa', key: 'company' },
        { label: 'Nº de envío', key: 'imported_id' },
        { label: 'Orden de flete', key: 'tracking_number' }
        // { label: 'Destinatario', key:'deliveryCountTable', class: ['text-center'] },
        // { label: 'Place_level3', key: 'statusNameTable' }
      ]
    },
    onChangeImportedIds() {
      const importedIds = this.getUniqueTrimmedIds()
      this.updateButtonAndWarning(importedIds.length)
    },

    getUniqueTrimmedIds() {
      return [...new Set(this.form.ids.split('\n').filter(Boolean).map(item => item.trim()))]
    },

    updateButtonAndWarning(length) {
      if (length === 0) {
        this.disabled.checkDeliveriesBtn = true
      } else if (length > 1000) {
        this.show.exceededWarning = true
        this.disabled.checkDeliveriesBtn = true
      } else {
        this.show.exceededWarning = false
        this.disabled.checkDeliveriesBtn = false
      }
    },
    checkDeliveries() {
      const importedIds = this.getUniqueTrimmedIds()
      this.checkDeliveriesToPrint(importedIds)
    },
    checkDeliveriesToPrint(imported_ids) {
      this.loading.checkDeliveries = true
      this.baseService.callService(this.endpointValues.checkDeliveriesToPrint, { imported_ids }, null, { fullResponseError: true })
        .then(resp => {
          this.checkDeliveriesData = {
            ...resp,
            process_deliveries_count: resp.process_deliveries.length
          }
          this.rows = resp.process_deliveries
          this.selectedRows = resp.process_deliveries.map(delivery => delivery.id)
          this.show.processDeliveries = resp.process_deliveries.length > 0
          this.show.failedDeliveries = resp.failed_deliveries.length > 0
          // Cambio de vista
          this.loading.checkDeliveries = false
          this.show.form = false
          this.show.responseDeliveries = true
        })
        .catch(err => {
          this.$alert(err)
        })
    },
    backToInputs() {
      this.show.form = true
      this.show.responseDeliveries = false
    },
    createSummaries() {
      // const selectedDeliveries = this.rows.filter(delivery => this.selectedRows.includes(delivery.id))
      this.loading.createSummariesBtn = true
      this.disabled.createSummariesBtn = true
      const queryParams = {
        deliveries: this.selectedRows
      }
      this.baseService.callService(this.endpointValues.printAndCloseSummary, queryParams, null, { fullResponseError: true })
        .then(resp => {
          this.$emit('sendGroupedSummaries', resp.data)
          this.onCloseModal()
        })
        .catch(err => {
          this.$alert(err.message)
        })
        .finally(() => {
          this.loading.createSummariesBtn = false
          this.disabled.createSummariesBtn = false
        })

    },
    onCloseModal() {
      this.$bvModal.hide('modalCreateMassiveSummaries')
      this.setAllDefault()
    },
    setAllDefault() {
      this.loading.checkDeliveries = false
      this.disabled.checkDeliveriesBtn = true
      this.show.exceededWarning = false
      this.form = {}
      this.show.form = true
      this.show.responseDeliveries = false
      this.disabled.createSummariesBtn = false
    }
  }
}
</script>

<style scoped>
  .modal-manifest--button--container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    padding: 2rem;
  }
  .highlighted-text {
    font-size: 1rem;
    font-weight: bold;
  }

  .custom-alert {
    padding: 0.5rem;
  }

  .error-text {
    font-size: 1.1rem;
  }
  .error-list-card {
    max-height: 30vh;
    overflow-y: auto;
  }
  .error-list-card::-webkit-scrollbar {
    width: 8px;
  }

  .error-list-card::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .error-list-card::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  .error-list-card::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
</style>